import { Box, Typography } from '@mui/material'
import styles from './SectionTabRow.module.scss'

function SectionTabRow({ label, Icon }) {
  return (
    <Box className={styles.tabRow}>
      <Box className={styles.labelRow}>
        {Icon ? (
          <Box component="span" className={styles.icon} aria-hidden>
            <Icon />
          </Box>
        ) : null}
        <Typography
          component="span"
          className={styles.label}
          sx={{ fontWeight: 600 }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  )
}

export default SectionTabRow
